import { Outlet, createFileRoute } from '@tanstack/react-router'
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { AppShell } from '../components/AppShell'
import { requireUser } from '../lib/auth'
import { leagueQuery, meQuery, roundQuery, roundsQuery } from '../lib/queries'

export const Route = createFileRoute('/l/$slug')({
  beforeLoad: ({ context, location }) => requireUser(context.queryClient, location.href),
  loader: ({ context, params }) => context.queryClient.ensureQueryData(leagueQuery(params.slug)),
  component: LeagueLayout,
})

function LeagueLayout() {
  const { slug } = Route.useParams()
  const { data: league } = useSuspenseQuery(leagueQuery(slug))
  useSuspenseQuery(meQuery) // the shell's account link reads this from cache
  // A dot on the Vote tab while a round is in voting and you have votes left.
  const rounds = useQuery(roundsQuery(slug))
  const voting = rounds.data?.find((r) => r.status === 'voting')
  const votingRound = useQuery({ ...roundQuery(slug, voting?.number ?? 0), enabled: !!voting })
  const badge = !!votingRound.data?.categories?.some((c) => c.my_votes_spent < league.vote_budget && c.submission_count > c.my_submission_count)

  return (
    <AppShell slug={slug} leagueName={league.name} voteBadge={badge}>
      <Outlet />
    </AppShell>
  )
}
